import {
    Token,
    GetOverwolfXpSubjectEnum,
    OverwolfApi,
    GetOverwolfXPResponse,
} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {keepPreviousData, useQuery} from "@tanstack/react-query";


async function fetchUserOverWolfXP(fullToken: Token, subject: GetOverwolfXpSubjectEnum, overwolfRewardId?: string, gameId?: string): Promise<GetOverwolfXPResponse> {
    return await new OverwolfApi(getConfig(fullToken)).getOverwolfXp({
        subject,
        overwolfRewardId,
        gameId,
    });
}

function useUserOverWolfXPQuery(fullToken: Token, subject: GetOverwolfXpSubjectEnum, overwolfRewardId?: string, gameId?: string) {
    // Create distinct query keys for filtered vs unfiltered TIME_REWARD calls
    const scope = gameId ? "game-specific" : "global";
    const queryKey = gameId
        ? [
            "user-overwolf-xp",
            fullToken?.id ?? "unauthenticated",
            subject,
            scope,
            gameId,
            overwolfRewardId ?? "",
        ]
        : [
            "user-overwolf-xp",
            fullToken?.id ?? "unauthenticated",
            subject,
            scope,
            overwolfRewardId ?? "",
        ];

    return {
        queryKey,
        queryFn: () => fullToken && subject ? fetchUserOverWolfXP(fullToken, subject, overwolfRewardId, gameId) : null,
        staleTime: 5 * 60000, // Reduced from 30 minutes to 5 minutes for faster cache updates
        placeholderData: keepPreviousData,
        enabled: !!fullToken && !!subject,
    } as const;
}

export default function useGetUserOverwolfXP(fullToken: Token, subject: GetOverwolfXpSubjectEnum, overwolfRewardId?: string, gameId?: string) {
    return useQuery(useUserOverWolfXPQuery(fullToken, subject, overwolfRewardId, gameId));
}
